import { render } from "./ProjectFaqContent.vue?vue&type=template&id=5763e100"
import script from "./ProjectFaqContent.vue?vue&type=script&lang=js"
export * from "./ProjectFaqContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__